<template>
    <div class="device-type-add">
        <el-page-header @back="goBack" content="创建群聊"></el-page-header>

        <div style="margin: 0 0 50px 0;">
            <span>群名称：</span>
            <el-input type="text" v-model="title_name" placeholder="请输入科室全称" autocomplete="off"
                      style="width: 30%;"></el-input>
        </div>

        <el-row class="inputs mg-20" :gutter="20" style="margin: 0 0 20px 0;">
            <el-col :span="6">
                <span class="fs-14 pd-r-10">姓名：</span>
                <el-input v-model="user_name" placeholder="姓名模糊搜索"/>
            </el-col>
            <el-col :span="6"> 
                <span class="fs-14 pd-r-10">手机号：</span>
                <el-input v-model="mobile" placeholder="手机号模糊搜索"/>
            </el-col>
            <el-col :span="6">
                <el-button @click="resetForm">重置</el-button>
                <el-button @click="search">搜索</el-button>
            </el-col>
            
        </el-row>

        <el-table ref="multipleTable"
                  :data="tableData"
                  border
                  style="width: 100%"
                  @selection-change="handleSelectionChange"
                  @select-all="selectAll"
                  :row-key="getRowKey">
            <el-table-column label-class-name="DisabledSelection" width="70px" type="selection" header-align="center"
                             align="center" :reserve-selection="true" ></el-table-column>
            <el-table-column label="设置群主（单选）">
                <template scope="scope">
                    <el-radio :label="scope.row.user_id" v-model="group_leader"
                              @change.native="getCurrentRow(scope.row)"></el-radio>
                </template>
            </el-table-column>
            <el-table-column prop="user_name" label="姓名" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="user_role" label="用户类型" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="mobile" label="手机号" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="create_date" label="创建时间" align="center" label-class-name="label"></el-table-column>
        </el-table>
        <el-pagination
                class="mg-20 ta-r"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :page-sizes="[5, 10, 25, 50, 100]"
                :total="total"
                :page-size="perpage"
                :current-page="page"
                @prev-click="changePage"
                @next-click="changePage"
                @current-change="changePage"
                @size-change="changeSite"
        ></el-pagination>

        <div>
            <el-button @click="goBack">取消</el-button>
            <el-button type="success" @click="submitForm()">保存</el-button>
        </div>
    </div>
</template>
<script>
    import env from "@/api/env";
    import {getUserInfos} from '@/utils/userInfos';
    import {check} from "@/utils/checkData";

    export default {
        mounted() {
            this.getList();
        },
        data() {
            return {
                allHospital: [],
                title_name: '',
                page: 1,
                perpage: 10,
                total: 0,
                tableData: [],
                user_name: '',
                mobile: '',
                group_leader: '',
                checkAllUser: [], // 所有群员
                allPage: [],
                isall:false,
                select_mobile:"",
                select_user_name:"",
            };
        },
       
        methods: {
            getRowKey(data) {
                return data.user_id;
            },

            // 选择群员
            handleSelectionChange(val) {
                this.checkAllUser = val;
            },

            // 选择群主
            getCurrentRow(data) {
                let flag = false;
                this.checkAllUser.forEach((multItem, j) => {
                    if (data.user_id == this.checkAllUser[j].user_id) {
                        flag = true;
                        return;
                    }

                })
                 if(!flag)
                {
                    alert("不能选择不是群组成员为群主");
                    this.group_leader = '';
                }
            },
            selectAll()
            {
    
                if(this.isall)
                {
                    this.isall = false;
                    this.$refs.multipleTable.clearSelection();

                }else{
                    this.isall = true;
                }
                
            },
            
            getList() {
                this.select_mobile = this.mobile;
                this.select_user_name = this.user_name;

                let params = {
                    servername: 'Ruyi_chatAdminServices',
                    method: 'createGroupByUser',
                    pageinfo: {
                        page: this.page,
                        perpage: this.perpage,
                    },
                    params: {
                        user_name: this.user_name,
                        mobile: this.mobile,
                    }
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }
                    for (var i = 0; i < res.data.data.list.length; i++) {
                        switch (res.data.data.list[i].user_role) {
                            case '1':
                                res.data.data.list[i].user_role = '特属服务对象';
                                break;
                            case '3':
                                res.data.data.list[i].user_role = '特属专家';
                                break;
                        }
                    }
                    this.tableData = res.data.data.list;
                    this.total = res.data.data.page.count;

                    this.$nextTick(function () {
                        if (this.tableData.length > 0 && this.checkAllUser.length > 0) {
                            this.tableData.forEach((item, i) => {
                                this.checkAllUser.forEach((multItem, j) => {
                                    if(this.isall)
                                    {
                                        this.$refs.multipleTable.toggleRowSelection(this.tableData[i], true);
                                    }
                                    else if (this.tableData[i].user_id == this.checkAllUser[j].user_id) {
                                        this.$refs.multipleTable.toggleRowSelection(this.tableData[i], true);
                                    }

                                })
                            })
                        }
                    })

                });
            },

            // 返回上一页
            goBack() {
                window.history.go(-1);
            },

            // 提交表单
            submitForm() {

                if (!this.title_name) {
                    this.$message({
                        type: "error",
                        message: '请输入群名称！'
                    });
                    return false;
                }
                if (!this.group_leader) {
                    this.$message({
                        type: "error",
                        message: '请选择群主！'
                    });
                    return false;
                }

                if (this.checkAllUser.length <= 0) {
                    this.$message({
                        type: "error",
                        message: '请选择群员！'
                    });
                    return false;
                }

                var allUser = [];
                for (var i = 0; i < this.checkAllUser.length; i++) {
                    if (this.checkAllUser[i].user_id != this.group_leader) {
                        // 群员中如果有群主则去掉
                        allUser.push(this.checkAllUser[i].user_id);
                    }
                }
                var allUserString = allUser.join(",");

                let params = {
                    servername: 'Ruyi_chatAdminServices',
                    method: 'createGroup',
                    params: {
                        create_user_id: this.group_leader,
                        chatroom_name: this.title_name,
                        users_ids: allUserString,
                        isall:this.isall,
                        user_name:this.select_user_name,
                        mobile:this.select_mobile,
                    },
                };

                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }

                    if (res.data.code != '0') {
                        this.$message({
                            type: "error",
                            message: '创建失败！'
                        });
                        return false;
                    } else {
                        this.$message({
                            type: "success",
                            message: '创建成功',
                            duration: 1500,
                            onClose: function () {
                                window.history.go(-1);
                            }
                        });
                    }


                });


            },

            // 改变每页条数
            changeSite(index) {
                this.perpage = index;
                this.getList();
            },

            //更换页码
            changePage(index) {
                this.page = index;
                this.getList();
            },

            // 重置按钮
            resetForm() {
                this.user_name = "";
                this.mobile = "";
                this.page = 1;
                this.getList();
            },

            // 搜索
            search() {
                this.page = 1;
                this.getList();
            },
        }

    };
</script>
<style lang="scss">
    @import "@/styles/common.scss";

    .el-table /deep/ .DisabledSelection .cell .el-checkbox__inner {
        margin-left: -30px;
        position: relative;
    }

    .el-table /deep/ .DisabledSelection .cell:before {
        content: "全选";
        position: absolute;
        right: 11px;
    }
</style>
